<script setup lang="ts">
import { useSystemStore } from '@/stores/system';
import { $BigNumber } from '@/utils';
import { Image } from 'vant';
import { computed, onMounted } from 'vue';
import 'wc-waterfall'
const systemStore = useSystemStore()
const CoinRate = computed(()=>{
  return systemStore.globalCurrency.rate || 1
})
const globalCurrency = computed(()=>{
  return systemStore.globalCurrency
})

const props = defineProps({
    data:<any>Array
})
</script>

<template>
  <wc-waterfall :gap="10" :cols="2">
    <router-link :to="`/integral/detail/${item.id}`" class="listitem" v-for="item in data" :key="item.id">
    <img :src="item.picUrl" />
    <div class="title">{{item.name}}</div>
    <div class="price">
    <div class="price-wrapper flex-row-start-center">
        <span>{{item.payIntegral/10000}}</span> <span class="text">STAR</span> <template v-if="item.price">
          <span class="add">+</span> <span class="symbol">{{globalCurrency.symbol}}</span>{{Number($BigNumber(item.price).div(100).times(CoinRate).toFixed(2))}}
        </template>
    </div>
    <div class="marketprice" v-if="item.marketPrice">市场价：{{globalCurrency.symbol}}{{Number($BigNumber(item.marketPrice).div(100).times(CoinRate).toFixed(2))}}</div>
    </div>
    </router-link>
  </wc-waterfall>
</template>

<style lang="scss" scoped>
.listitem {
  display: flex;
  padding: 6px 6px 8px 6px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  border-radius: 12px;
  background: #1f212d;
  :deep(img) {
    width: 100%;
    border-radius: 12px;
  }
  .title {
    color: #fff;
    font-family: Montserrat;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* 定义文本的行数 */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal; /* 使用normal或pre-wrap使文本正常换行 */
    width: 100%; /* 定义容器宽度 */
    text-transform: capitalize;
    overflow: hidden;
    color: #FFF;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px; /* 150% */
    text-transform: capitalize;
  }
  .price {
    color: $themColor2;
    font-family: 'D-DINExp';
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 125% */
    .price-wrapper{
      gap:4px
    }
    .text {
      font-family: 'D-DINExp';
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 166.667% */
    }
    .add {
      font-family: 'D-DINExp';
      font-size: 26px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px; /* 61.538% */
      margin-bottom: 3px;
    }
    .symbol {
      font-family: 'D-DIN Exp';
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px; /* 133.333% */
    }
    .marketprice {
      color: $text2;
      font-family: Poppins;
      font-size: 10px;
      font-style: normal;
      font-weight: 400;
      line-height: 14px; /* 140% */
      text-decoration: line-through;
      margin-top: 4px;
    }
  }
}

</style>
